// Short accept/reject chimes for gate scanning, generated with the Web Audio API
// (no audio files). Staff can mute from the app header; preference is remembered.
const ENABLED_KEY = "st_staff_sound";

let ctx = null;
function actx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

// Call on a user gesture so mobile browsers allow later programmatic sounds.
export function resumeAudio() {
  const c = actx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

export function isSoundEnabled() {
  try { return localStorage.getItem(ENABLED_KEY) !== "0"; } catch { return true; }
}
export function setSoundEnabled(on) {
  try { localStorage.setItem(ENABLED_KEY, on ? "1" : "0"); } catch { /* noop */ }
  if (on) resumeAudio();
}

function beep(freq, start, dur, type = "sine", gain = 0.18) {
  const c = actx();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + start;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur + 0.02);
}

export function playAccept() {
  if (!isSoundEnabled()) return;
  resumeAudio();
  beep(880, 0, 0.09, "sine", 0.2);
  beep(1320, 0.1, 0.13, "sine", 0.2);
}

export function playReject() {
  if (!isSoundEnabled()) return;
  resumeAudio();
  beep(250, 0, 0.22, "square", 0.16);
  beep(180, 0.13, 0.24, "square", 0.16);
}

export function playQueued() {
  if (!isSoundEnabled()) return;
  resumeAudio();
  beep(620, 0, 0.14, "triangle", 0.16);
}
